import {Component, Input} from "@angular/core";
import {FormControl} from "@angular/forms";
import {Observable} from "rxjs";
import {PopParentVerticalAlignment} from "../../../pops/abstract-pop";

@Component({
    selector: "fui-validations",
    templateUrl: "./validations.component.html"
})
export class FUIValidationsComponent {
    @Input() public forceRequired: boolean;
    @Input() public control: FormControl;
    @Input() public focussed: boolean;
    @Input() public errorVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.ABOVE;

    get required(): Observable<boolean> {
        return this.control["required$"];
    }
}
